<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5.013A6.49 6.49 0 0 0 .013 6.5 6.49 6.49 0 0 0 6.5 12.987 6.49 6.49 0 0 0 12.987 6.5 6.49 6.49 0 0 0 6.5.013ZM7.691 6.84c0-.658-.533-1.191-1.19-1.191H6.5a1.191 1.191 0 0 0-1.191 1.191v2.536a1.191 1.191 0 0 0 1.191 1.19c.658 0 1.191-.533 1.191-1.19V6.84ZM6.5 2.432a1.192 1.192 0 1 0 .001 2.384A1.192 1.192 0 0 0 6.5 2.432Z"
      fill="currentColor"
    />
  </svg>
</template>
